import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IPromise, IRootScopeService, ITimeoutService, IWindowService} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {BrukerRessurs} from "felles/tjenester/ressurser/BrukerRessurs";
import {Autentisering} from "felles/tjenester/Autentisering";
import {MeldingTilBruker, Varighet} from "felles/tjenester/MeldingTilBruker";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {Avtalestatus} from "felles/tjenester/ressurser/AvtaleRessurs";
import {klientUtdatertEvent} from "felles/infrastruktur/ApiVersjonResponsHeadereInterceptor";
import {Dialog} from "./Dialog";
import {l} from "../../types/typescriptdefinisjoner_lederplan";
import Tokenvarighet = l.Tokenvarighet;
import {Debugger} from "debug";
import {Konfigurasjon} from "../../felles/infrastruktur/Konfigurasjon";
import {AutentiserMedHøyereSikkerhetsnivåKontroller} from "../moduler/innlogging/modale/autentiserMedHøyereSikkerhetsnivå/autentiserMedHøyereSikkerhetsnivå";
import {BekreftMobilnummerDialog} from "../moduler/bruker/modale/bekreftMobilnummer/bekreftMobilnummerDialog";

const debug: Debugger = require('debug')('MeldingTilBrukerVedInnlogging');

/** Ansvarlig for å vise meldinger til bruker ved innlogging relatert til brukers tilstand */
export class MeldingTilBrukerVedInnlogging {

    static eventer = {klikkPåOppgraderTilMediumTokenvarighetNåLoggetUt: "MeldingTilBrukerVedInnlogging.klikkPåoppgraderTilMediumTokenvarighet"};
    static regNavn = "wt.MeldingTilBrukerVedInnlogging";

    static forInjisering() {
        return [regNavn.ng.$rootScope,
            regNavn.ng.$timeout,
            regNavn.ng.$window,
            regNavn.md.$mdDialog,
            Kontekst.regNavn,
            MeldingTilBruker.regNavn,
            Autentisering.regNavn,
            BrukerRessurs.regNavn,
            Konfigurasjon.regNavn,
            regNavn.gettext.gettextCatalog,
            Dialog.regNavn,
            WebNavigasjon.regNavn,
            MeldingTilBrukerVedInnlogging]
    }

    constructor(private $rootScope: IRootScopeService,
                private $timeout:ITimeoutService,
                private $window: IWindowService,
                private $mdDialog: angular.material.IDialogService,
                private kontekst: Kontekst,
                private meldingTilBruker: MeldingTilBruker,
                private autentisering: Autentisering,
                private brukerRes: BrukerRessurs,
                private konfigurasjon: Konfigurasjon,
                private gettextCatalog: gettextCatalog,
                private dialog: Dialog,
                private navigasjon: WebNavigasjon) {
    }

    private prøveperiodeUtløptMelding = null;
    private avtaleTerminertMelding = null;
    private epostIkkeBekreftetMelding = null;
    private mobilnummerIkkeBekreftetMelding = null;
    private oppgraderSesjonMelding = null;
    private ikkeTilgangTilAlleGrupperMelding = null;
    private ubesvarteInvitasjonerMelding = null;
    private visOppgraderSesjonMeldingTimer:IPromise<any> = null;
    private klientUtdatertVarselVist = false;

    public lyttTilBrukerLoggetInnEventOgVisMeldinger() {
        this.$rootScope.$on(Autentisering.brukerAutentisertEvent, () => {
            this.visPrøveperiodeUtløptVarsel();
            this.visAvtaleTerminertVarsel();
            this.visEpostIkkeBekreftetVarsel();
            this.visMobilnummerIkkeBekreftetVarsel();
            this.visForsinketOppgraderSesjonMelding();
            this.visIkkeTilgangTilAlleGrupperVarsel();
            this.visUbesvarteInvitasjonerVarsel();
            this.visGammelNettleserVarsel();
        });
        this.$rootScope.$on(Autentisering.brukerLoggetUtEvent, () => {
            this.kanselerVisForsinketOppgraderSesjonMelding();
            if (this.prøveperiodeUtløptMelding) this.meldingTilBruker.fjernMelding(this.prøveperiodeUtløptMelding);
            this.prøveperiodeUtløptMelding = null;
            if (this.avtaleTerminertMelding) this.meldingTilBruker.fjernMelding(this.avtaleTerminertMelding);
            this.avtaleTerminertMelding = null;
            if (this.epostIkkeBekreftetMelding) this.meldingTilBruker.fjernMelding(this.epostIkkeBekreftetMelding);
            this.epostIkkeBekreftetMelding = null;
            if (this.mobilnummerIkkeBekreftetMelding) this.meldingTilBruker.fjernMelding(this.mobilnummerIkkeBekreftetMelding);
            this.mobilnummerIkkeBekreftetMelding = null;
            if (this.oppgraderSesjonMelding) this.meldingTilBruker.fjernMelding(this.oppgraderSesjonMelding);
            this.oppgraderSesjonMelding = null;
            if (this.ikkeTilgangTilAlleGrupperMelding) this.meldingTilBruker.fjernMelding(this.ikkeTilgangTilAlleGrupperMelding);
            this.ikkeTilgangTilAlleGrupperMelding = null;
            if (this.ubesvarteInvitasjonerMelding) this.meldingTilBruker.fjernMelding(this.ubesvarteInvitasjonerMelding);
            this.ubesvarteInvitasjonerMelding = null;
        });
    }

    public lyttTilBrukerRelastetEventOgVisMeldinger() {
        this.$rootScope.$on(Kontekst.brukerRelastetEvent, () => {
            this.visPrøveperiodeUtløptVarsel();
            this.visAvtaleTerminertVarsel();
            this.visEpostIkkeBekreftetVarsel();
            this.visMobilnummerIkkeBekreftetVarsel();
            this.visIkkeTilgangTilAlleGrupperVarsel();
            this.visUbesvarteInvitasjonerVarsel();
            this.visGammelNettleserVarsel();
        });
    }

    public lyttTilKlientUtdatertEventOgVisMelding() {
        this.$rootScope.$on(klientUtdatertEvent, () => {
            if (this.klientUtdatertVarselVist) return;

            this.klientUtdatertVarselVist = true;
            this.visKlientUtdatertVarsel();
        });
    }

    //hjelpemetoder

    private visPrøveperiodeUtløptVarsel() {
        const info = _(this.kontekst.avtalerBrukerErKontaktpersonFor())
            .map(org => ({avtale: org, avtalestatus: new Avtalestatus(org)}))
            .filter(info => info.avtalestatus.proeveperiodeUtloept)
            .sortBy(info => info.avtalestatus.dagerIgjenFoerSletting)
            .first();

        this.meldingTilBruker.fjernMelding(this.prøveperiodeUtløptMelding);

        if (!info) return;

        const melding = this.gettextCatalog.getString('Prøveperioden for \'{{avtalenavn}}\' er utløpt, du har nå kun lesetilgang til dine data. <a>Oppgi faktureringsinformasjon nå</a> for å unngå at avtalen og tilknyttede grupper slettes om {{dagerIgjenFoerSletting}} dager.', {
            avtalenavn: info.avtale.navn,
            dagerIgjenFoerSletting: info.avtalestatus.dagerIgjenFoerSletting
        });
        this.prøveperiodeUtløptMelding = this.meldingTilBruker.advarselmelding(`<span class="e2e-proeveperiode-utlopet-mld">${melding}</span>`, Varighet.klikkBort, () => {
            this.navigasjon.gåTilRedigerFaktureringsinformasjon(info.avtale.id);
            return false;
        });
    }

    private visAvtaleTerminertVarsel() {
        const info = _(this.kontekst.avtalerBrukerErKontaktpersonFor())
            .map(org => ({avtale: org, avtalestatus: new Avtalestatus(org)}))
            .filter(info => info.avtalestatus.avtaleTerminert)
            .sortBy(info => info.avtalestatus.dagerIgjenFoerSletting)
            .first();

        this.meldingTilBruker.fjernMelding(this.avtaleTerminertMelding);

        if (!info) return;

        const melding = this.gettextCatalog.getString('Avtalen for \'{{avtalenavn}}\' er avsluttet, du har nå kun lesetilgang til dine data. Avtalen og tilknyttede grupper slettes om {{dagerIgjenFoerSletting}} dager.', {
            avtalenavn: info.avtale.navn,
            dagerIgjenFoerSletting: info.avtalestatus.dagerIgjenFoerSletting
        });
        this.avtaleTerminertMelding = this.meldingTilBruker.advarselmelding(`<span class="e2e-avtale-terminert-mld">${melding}</span>`, Varighet.klikkBort, () => {
            return false; //ikke skjul ved klikk (kan dog skjules ved å trykke på X)
        });
    }

    private visForsinketOppgraderSesjonMelding() {
        this.meldingTilBruker.fjernMelding(this.oppgraderSesjonMelding);

        if (this.kontekst.aktivtTokenInfo().tokenvarighet !== Tokenvarighet.kort) return;
        this.visOppgraderSesjonMeldingTimer = this.$timeout(() => this.visOppgraderSesjonMelding(), this.konfigurasjon.kortTokenOppgraderVarselForsinkelse.asMilliseconds());
    }

    private kanselerVisForsinketOppgraderSesjonMelding(){
        this.$timeout.cancel(this.visOppgraderSesjonMeldingTimer);
    }

    private visEpostIkkeBekreftetVarsel() {
        if (this.kontekst.autentisertBruker().epostErBekreftet) {
            this.meldingTilBruker.fjernMelding(this.epostIkkeBekreftetMelding);
            return;
        }

        if (this.epostIkkeBekreftetMelding) return;

        const melding = this.gettextCatalog.getString('Du har ikke bekreftet e-postadressen din, gjør dette ved å klikke på \'bekreft din e-postadresse\' i velkomst e-posten vi sendte deg. Finner du ikke e-posten - <a>la oss sende deg en ny.</a>');
        this.epostIkkeBekreftetMelding = this.meldingTilBruker.advarselmelding(`<span class="e2e-epost-ikke-bekreftet-mld">${melding}</span>`, Varighet.klikkBort, () => {
            this.sendBekreftEpostadresseToken();
            return true; //skjuler meldingen når bruker klikker på denne
        });
    }

    private sendBekreftEpostadresseToken() {
        this.brukerRes.sendBekreftEpostadresseToken().$promise
            .then(respons => {
                if (!respons.sendt) return;
                const melding = this.gettextCatalog.getString('Ny bekreftelses-e-post med tittel \'{{eposttittel}}\' har blitt sendt til {{epostadresse}}', {
                    eposttittel: respons.meldingstittel,
                    epostadresse: respons.epostadresse
                });
                this.meldingTilBruker.advarselmelding(`<span class="e2e-ny-bekreft-epost-sendt-mld">${melding}</span>`, Varighet.sideskift);
            });
    }

    private visMobilnummerIkkeBekreftetVarsel() {
        if (this.kontekst.autentisertBruker().mobilnummerErBekreftet || _.isNil(this.kontekst.autentisertBruker().mobilnummer)) {
            this.meldingTilBruker.fjernMelding(this.mobilnummerIkkeBekreftetMelding);
            return;
        }

        if (this.mobilnummerIkkeBekreftetMelding) return;

        let melding = this.gettextCatalog.getString('Du har ikke bekreftet mobiltelefonnummeret ditt, gjør dette ved å <a>klikke her</a>.');
        if(_.includes(this.kontekst.autentisertBruker().autentiseringsmetoder, l.Autentiseringsmetode.smsOtp))
            melding = melding + ' ' + this.gettextCatalog.getString('Merk at innlogging med engangskode per SMS ikke vil være mulig før dette er gjort.');

        this.mobilnummerIkkeBekreftetMelding = this.meldingTilBruker.advarselmelding(`<span class="e2e-sms-ikke-bekreftet-mld">${melding}</span>`, Varighet.klikkBort, () => {
            this.visBekreftMobiltelefonnummerDialog();
            return true; //skjuler meldingen når bruker klikker på denne
        });
    }

    private visBekreftMobiltelefonnummerDialog() {
        BekreftMobilnummerDialog.visBekreftMobilnummerDialog(this.$mdDialog)
            .then(()=>{
                this.mobilnummerIkkeBekreftetMelding = null;
            })
            .catch(()=>{
                this.mobilnummerIkkeBekreftetMelding = null;
                this.visMobilnummerIkkeBekreftetVarsel(); //sørger for at varsel vises på nytt dersom bruker avbrøt visBekreftMobilnummerDialog
            });
    }

    private visKlientUtdatertVarsel() {
        const melding = this.gettextCatalog.getString('Vi har oppdatert systemet, for at du skal få glede av dette må siden lastes på nytt. <a>Klikk her for å gjøre dette</a>');
        this.meldingTilBruker.advarselmelding(`<span class="e2e-klient-utdatert-mld">${melding}</span>`, Varighet.klikkBort, () => this.relastApplikasjonen());
    }

    private visUbesvarteInvitasjonerVarsel() {
        if (_.isEmpty(this.kontekst.invitasjonerTilGodkjenning())) {
            this.meldingTilBruker.fjernMelding(this.ubesvarteInvitasjonerMelding);
            return;
        }

        if (this.ubesvarteInvitasjonerMelding) return;

        const melding = this.gettextCatalog.getString('Du har ubesvarte gruppeinvitasjoner. <a>Klikk her for å akseptere eller avslå invitasjonene.</a>');
        this.ubesvarteInvitasjonerMelding = this.meldingTilBruker.advarselmelding(`<span class="e2e-ubesvarteInvitasjoner-mld">${melding}</span>`, Varighet.klikkBort, () => {
            this.navigasjon.gåTilGrupper();
            return false; //skjuler ikke meldingen når bruker klikker på denne - meldingen skjules når bruker avslått/godtatt invitasjonen
        });
    }

    private visIkkeTilgangTilAlleGrupperVarsel() {
        if (_.isEmpty(this.kontekst.grupperSomKreverAnnenAutentiseringsmetode())) {
            this.meldingTilBruker.fjernMelding(this.ikkeTilgangTilAlleGrupperMelding);
            return;
        }

        if (this.ikkeTilgangTilAlleGrupperMelding) return;

        const melding = this.gettextCatalog.getString('Gruppene <i>{{grupper}}</i> krever at du logger inn med et høyere sikkerhetsnivå og er derfor skjult. <a>Klikk her for å logge inn med tilstrekkelig sikkerhetsnivå.</a>', {
            grupper: this.kontekst.grupperSomKreverAnnenAutentiseringsmetode().map(g => this.gettextCatalog.getString('{{tittel}} i {{organisasjonsnavn}}', {tittel: g.gruppe.tittel, organisasjonsnavn: g.gruppe.organisasjonsnavn})).join(', ')
        });
        this.ikkeTilgangTilAlleGrupperMelding = this.meldingTilBruker.advarselmelding(`<span class="e2e-krever-høyere-sikkerhetsnivå-mld">${melding}</span>`, Varighet.klikkBort, () => {
            AutentiserMedHøyereSikkerhetsnivåKontroller.visAutentiserMedHøyereSikkerhetsnivå(this.$mdDialog)
            return false; //skjuler ikke meldingen når bruker klikker på denne - meldingen skjules når bruker har oppgradert sikkerhetsnivå
        });
    }

    private visOppgraderSesjonMelding(){
        //tilfelle bruker har logget ut
        if (this.kontekst.erAutentisert() && this.kontekst.aktivtTokenInfo().tokenvarighet !== Tokenvarighet.kort) return;

        const melding = this.gettextCatalog.getString('Klikk her dersom du ønsker å forbli innlogget i 30 dager');
        this.oppgraderSesjonMelding = this.meldingTilBruker.infomelding(`<span class="e2e-oppgradersesjon-mld">${melding}</span>`, Varighet.klikkBort, () => {
            this.oppgraderTilMediumTokenvarighet();
            return true; //skjuler meldingen når bruker klikker på denne
        });
    }

    private visGammelNettleserVarsel(){
        //BigInt64Array kom i ecma2020 og er inkl i safari fom 15, BigInt fom safari 14
        if (typeof BigInt64Array === 'function') return;
        const melding = this.gettextCatalog.getString('Eldre versjoner av nettlesere fungerer ikke optimalt. Sørg for at du har en oppdatert versjon.');
        const lenketekst = this.gettextCatalog.getString('Se Policy for nettlesere her.');
        this.meldingTilBruker.feilmelding(`${melding} <a href="https://support.styreplan.no/no/article/stottede-nettlesere-1pvix4y/" target="_blank">${lenketekst}</a>`, Varighet.klikkBort);
    }

    /** Sørger for å oppgradere til medium tokenvarighet.
     * Trigger event dersom bruker allerede har blitt logget ut. */
    private oppgraderTilMediumTokenvarighet(){
        if (this.kontekst.erAutentisert())
            this.autentisering.oppgraderTilMediumToken();
        else
            this.$rootScope.$broadcast(MeldingTilBrukerVedInnlogging.eventer.klikkPåOppgraderTilMediumTokenvarighetNåLoggetUt);
    }

    private relastApplikasjonen() {
        this.dialog.confirm(
            ///tittel på dialog som vises når bruker velger å relaste side etter å klikket på melding om at ny versjon av webapplikasjonen er tilgjengelig
            this.gettextCatalog.getString('Relast siden'),
            ///melding som vises når bruker velger å relaste side etter å klikket på melding om at ny versjon av webapplikasjonen er tilgjengelig
            this.gettextCatalog.getString('<p>Du er i ferd med å relaste denne siden.</p><p>Klikk på avbryt dersom du har ulagret innhold på siden!</p>'),
            ///tittel knapp i dialog som vises når bruker velger å relaste side etter å klikket på melding om at ny versjon av webapplikasjonen er tilgjengelig
            this.gettextCatalog.getString('Relast'),
            ///tittel knapp i dialog som vises når bruker velger å relaste side etter å klikket på melding om at ny versjon av webapplikasjonen er tilgjengelig
            this.gettextCatalog.getString('Avbryt')
        ).then(() => {
            this.$window.location.reload();
        });

        return false;//ikke skjul meldingen - dersom bruker velger å relaste vil meldingen uansett ikke vises på nytt..
    }
}
